export enum RecoveryActionEnum {
  RecoveryForm = 1,
  RecoveryOptions = 2,
  TokenReceived = 3,
  RecoveryQuestions = 4,
  PasswordRedefinition = 5,
  AlertRecoveryQuestions = 6,
  ConfirmationData = 7,
  QuestionsToRecovery = 8
}